import { useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { MenuItem } from "react-bootstrap";
import ConfirmationModal from "lcm-iot-commons/client/lib/components/ConfirmationModal";
import { intlShape, ItemMenu, ListItem } from "lcm-iot-commons";

import { accessRightsShape } from "../../shapes/accessRightsShape";

type OwnProps = {
  intl: intlShape;
  accessRights: accessRightsShape;
  onDelete: $TSFixMeFunction;
  disabled?: boolean;
  item: {
    id?: string;
    name?: string;
  };
};

const defaultProps: Partial<OwnProps> = {
  disabled: false,
};

type Props = OwnProps & typeof defaultProps;

export function OpcUaServerWhitelistItem({
  intl,
  onDelete,
  item,
  accessRights,
  disabled,
}: Props) {
  const [deleting, setDeleting] = useState(false);

  const handleOnConfirm = () => {
    setDeleting(false);
    onDelete(item.id);
  };

  return (
    <>
      <ListItem
        id={`whitelist-item-${item.id}`}
        icon="icon2-eh-record"
        title={item.name}
        actions={
          <ItemMenu>
            <MenuItem
              id={`whitelist-item-delete-${item.id}`}
              onSelect={() => setDeleting(true)}
              disabled={!accessRights.canUpdate || disabled}
            >
              <FormattedMessage id="button.delete" />
            </MenuItem>
          </ItemMenu>
        }
      />
      {deleting && (
        <ConfirmationModal
          id={`whitelist-item-delete-modal-${item.id}`}
          show
          titleText={intl.formatMessage({
            id: "whitelist_item_delete.actions.modal_title",
          })}
          messageText={intl.formatMessage(
            { id: "whitelist_item_delete.actions.modal_message" },
            { item: item.name },
          )}
          onConfirm={handleOnConfirm}
          onClose={() => setDeleting(false)}
        />
      )}
    </>
  );
}

OpcUaServerWhitelistItem.defaultProps = defaultProps;

export default injectIntl(OpcUaServerWhitelistItem);
